import LeftSideBar from './LeftSideBar';
import RightSideBar from './RightSideBar';

export default {
  LeftSideBar,
  RightSideBar
}

export {
  LeftSideBar,
  RightSideBar
}


// WEBPACK FOOTER //
// ./src/components/SideBar/index.js